import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import { KeyboardArrowRight, MoreHoriz } from "@material-ui/icons";
import { flatten } from "lodash";

import "./styles.scss";
import FirstStationTitle from "../FirstStationTitle";
import StationTitle from "../StationTitle";
import { langStringConvertor } from "../../utils/utils";
import Constants from "../../utils/constants";

const { LANGUAGES } = Constants;
const { start, end } = LANGUAGES;

const SmallEtaCard = (props) => {
  const {
    origin,
    destination,
    stations,
    redirect,
    eta,
    displayType,
    court,
    routeCode,
    showLicensePlate,
    vehicleLocations
  } = props;

  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(props.language);
  }, [props.language]);

  return (
    <div className="small-eta-card" onClick={redirect}>
      <div className="title">
        {language === "zh" || language === "cn" ? (
          displayType === "combineStops" ? (
            <span className={language}>
              {`${routeCode ? routeCode : ""}來往 ${destination}`}
            </span>
          ) : (
            <span className={language}>
              {`${routeCode ? routeCode : ""}由 ${origin} `}往 {destination}
            </span>
          )
        ) : displayType === "combineStops" ? (
          <span className={language}>{`${
            routeCode ? routeCode : ""
          }To ${destination}`}</span>
        ) : (
          <span className={language}>
            {`${routeCode ? routeCode : ""}From ${origin} `}
            To {destination}
          </span>
        )}
        <span className="click-arrow">
          <KeyboardArrowRight style={{ fontSize: 24 }} />
        </span>
      </div>
      <div className="content">
        {eta &&
          stations.map((station, index) => {
            if (stations.length > 3) {
              if (index !== stations.length - 1 && index !== 0) {
                if (index === 2) {
                  return (
                    <div className="station-title-container">
                      <div className="dot-container">
                        <div className={`dot middle ${court}`}></div>
                        <MoreHoriz
                          style={{ marginLeft: "10px", color: "#4F4F4F" }}
                        />
                      </div>
                    </div>
                  );
                } else {
                  return <></>;
                }
              }
            }

            const tempEta = eta
              .flatMap((el) => el.eta)
              .filter((el) => el.stopId === station.stop_id)
              .flatMap((el) => el.eta)
              .sort((a, b) => a.diff - b.diff);

            const stationEta = tempEta;
            const isLastStation = index === stations.length - 1;

            //if firstEta is realtime 0mins, then use the second one
            const isFirstEtaRealtime =
              index === 0 &&
              stationEta?.[0]?.diff === 0 &&
              !stationEta?.[0]?.remarks_en;

            return (
              <StationTitle
                title={station[`name_${langStringConvertor(language)}`]}
                time={
                  isFirstEtaRealtime
                    ? stationEta?.[1]?.diff
                    : stationEta?.[0]?.diff
                }
                timestamp={
                  isFirstEtaRealtime
                    ? stationEta?.[1]?.timestamp
                    : stationEta?.[0]?.timestamp
                }
                remarks={
                  isFirstEtaRealtime
                    ? stationEta?.[1]?.[
                        `remarks_${langStringConvertor(language)}`
                      ]
                    : stationEta?.[0]?.[
                        `remarks_${langStringConvertor(language)}`
                      ]
                }
                index={index}
                isLastStation={isLastStation}
                notes={
                  index === 0
                    ? start[language]
                    : isLastStation
                    ? end[language]
                    : null
                }
                language={language}
                court={court}
                showLicensePlate={showLicensePlate}
                vehicleLocations={vehicleLocations}
              />
            );
          })}
      </div>
    </div>
  );
};

export default SmallEtaCard;
